import styled from 'styled-components';

export const RequiredTasksWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SectionTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.textPrimarySecondary1100};
`;

export const TaskSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const EmptyStateBox = styled.div`
  border: 1px dashed ${({ theme }) => theme.colors.backgroundAccentGreySubtleGrey10};
  border-radius: 8px;
  padding: 16px;
  text-align: center;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textSecondaryGrey90};
`;
